/*jshint esversion: 6 */
/*jshint sub:true*/
import axios from 'axios';
import {extractErrorDetails} from '@/helpers/util.js';

const groupBugs = function (inc_bugs) {
  let bugs = JSON.parse(JSON.stringify(inc_bugs));
  let index_obj = {};
  let grouped_bugs = [];
  for (let i = 0; i < bugs.length; i++) {
    const key = bugs[i].identifier + bugs[i].error + bugs[i].browser + bugs[i].os + bugs[i].website_version;
    if (index_obj[key] !== undefined) {
      grouped_bugs[index_obj[key]].ids.push(bugs[i].id);
      grouped_bugs[index_obj[key]].count = grouped_bugs[index_obj[key]].ids.length;
    } else {
      grouped_bugs.push(bugs[i]);
      index_obj[key] = grouped_bugs.length - 1;
    }
  }
  return grouped_bugs;
};


const initialState = () => ({
  actions: [],
  mutations: [],
  bug_dialog: { show: false, payload: {}},
  details_dialog: { show: false, actions: [], mutations: [] },
  open_bugs: [],
  dev_bugs: [],
  closed_bugs: [],
  error: '',
  loading: false,
  sort_by: 'os',
  sort_type: 'ascending',
  meta_data: {}
});

// State object
const state = initialState();
// Getter functions
const getters = {
  getActions: (state) => state.actions,
  getMutations: (state) => state.mutations,
  getBugDialog: (state) => state.bug_dialog,
  getDetailsDialog: (state) => state.details_dialog,
  getOpenBugs: (state) => state.open_bugs,
  // getOpenBugs: (state) => {
  //   let open_bugs = JSON.parse(JSON.stringify(state.open_bugs));
  //   return open_bugs.sort(function(a, b) {
  //     let nameA = [];
  //     let nameB = [];

  //     if (state.sort_type == 'ascending') {
  //       nameA = a[state.sort_by].toUpperCase();
  //       nameB = b[state.sort_by].toUpperCase();
  //     } else {
  //       nameB = a[state.sort_by].toUpperCase();
  //       nameA = b[state.sort_by].toUpperCase();
  //     }

  //     if (nameA < nameB) {
  //       return -1;
  //     }
  //     if (nameA > nameB) {
  //       return 1;
  //     }
  //     return 0;
  //     });
  // },
  getDevelopmentBugs: (state) => state.dev_bugs,
  getClosedBugs: (state) => state.closed_bugs,
  getSortBy: (state) => state.sort_by,
  getSortType: (state) => state.sort_type,
};
// Actions
const actions = {
  appendAction({commit}, action){
    commit('append_action', action);
  },
  appendMutation({commit}, mutation){
    commit('append_mutation', mutation);
  },
  sendBugReport({commit}, payload){

    const json = require('../../../package.json');

    let os_name = "Unknown OS";
    if (navigator.appVersion.indexOf("Win")!=-1) os_name="Windows";
    if (navigator.appVersion.indexOf("Mac")!=-1) os_name="MacOS";
    if (navigator.appVersion.indexOf("X11")!=-1) os_name="UNIX";
    if (navigator.appVersion.indexOf("Linux")!=-1) os_name="Linux";

    let browser = navigator.sayswho= (function(){
        let ua= navigator.userAgent, tem,
        M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if(/trident/i.test(M[1])){
            tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
            return 'IE '+(tem[1] || '');
        }
        if(M[1]=== 'Chrome'){
            tem= ua.match(/\b(OPR|Edge?)\/(\d+)/);
            if(tem!= null) return tem.slice(1).join(' ').replace('OPR', 'Opera').replace('Edg ', 'Edge ');
        }
        M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
        if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
        return M.join(' ');
    })();

    axios({
      url: 'bugs',
      method: 'POST',
      data: {
        identifier: payload.actions[payload.actions.length - 1].name,
        error: payload.error.status + ' ' + payload.error.statusText + ' ' + payload.error.msg,
        actions: payload.actions,
        mutations: payload.mutations,
        browser: browser,
        os: os_name,
        website_version: json.version,
      }
    })
    .then(() => {
      commit('toggle_bug_dialog', {
        show: false
      });
    });
    // .catch(err => {
    //
    // });
  },
  requestBugsForManagement({commit}, suffix) {
    return new Promise((resolve, reject) => {
      commit('set_loading', true);
      axios({
        url: 'bugs' + suffix,
        method: 'GET',
        headers: {'Cache-Control': 'no-cache'}
      })
      .then(resp => {
        let open_bugs = [];
        let dev_bugs = [];
        let closed_bugs = [];
        for (let i = 0; i < resp.data.data.length; i++) {
          switch (resp.data.data[i].status) {
            case 'open':
              open_bugs.push(resp.data.data[i]);
              break;
            case 'development':
              dev_bugs.push(resp.data.data[i]);
              break;
            case 'closed':
              closed_bugs.push(resp.data.data[i]);
              break;
          }
        }
        commit('set_bug_meta', resp.data.meta_data);
        commit('set_open_bugs', open_bugs);
        commit('set_dev_bugs', dev_bugs);
        commit('set_closed_bugs', closed_bugs);
        commit('set_loading', false);
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        commit('set_loading', false);
        reject();
      });
    });
  },
  requestActionsMutations({commit}, payload){
    axios({
      url: 'bugs/0/actions-and-mutations' +
            '?identifier=' + payload.identifier +
            '&status=' + payload.status +
            '&error=' + payload.error +
            '&browser=' + payload.browser +
            '&os=' + payload.os +
            '&website_version=' + payload.website_version,
      method: 'GET'
    })
    .then(resp => {
      commit('set_details_dialog', {
        show: true,
        actions: resp.data.data.actions,
        mutations: resp.data.data.mutations
      });
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
      commit('set_loading', false);
    });
  },
  toggleBugDialog({commit}, payload){
    commit('toggle_bug_dialog', payload);
  },
  resetDetailsDialog({commit}){
    commit('reset_details_dialog');
  },
  setBugList({commit}, payload){
    switch (payload.status) {
      case 'open':
        commit('set_open_bugs', groupBugs(payload.bugs));
        break;
      case 'development':
        commit('set_dev_bugs', groupBugs(payload.bugs));
        break;
      case 'closed':
        commit('set_closed_bugs', groupBugs(payload.bugs));
        break;
    }
  },
  changeBugStatus({commit}, payload){
    axios({
      url: 'bugs/' + payload.id,
      method: 'PUT',
      data: {
        'status': payload.status
      }
    })
    .then(() => {
      commit('change_bug_status', payload);
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  },
  deleteBug({commit}, payload){
    axios({
      url: 'bugs/' + payload.id,
      method: 'DELETE',
      headers: {'Cache-Control': 'no-cache'}
    })
    .then(() => {
      commit('remove_open_bug', payload.index);
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
      commit('View/set_user_feedback', err.response.data.error, { root: true });
    });
  },
  setSortBy({commit}, payload){
    commit('set_sort_by', payload);
  },
  setSortType({commit}, payload){
    commit('set_sort_type', payload);
  },
};
// Mutations
const mutations = {
  append_action(state, action){
    state.actions.push(action);
    if (state.actions.length > 20) {
      state.actions.shift();
    }
  },
  append_mutation(state, mutation){
    state.mutations.push(mutation);
    if (state.mutations.length > 20) {
      state.mutations.shift();
    }
  },
  change_bug_status(state, payload){
    switch (payload.status) {
      case 'open':
        state.open_bugs[payload.index].status = payload.status;
        break;
      case 'development':
        state.dev_bugs[payload.index].status = payload.status;
        break;
      case 'closed':
        state.closed_bugs[payload.index].status = payload.status;
        break;
    }
  },
  reset(state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
  reset_details_dialog(state){
    state.details_dialog = { show: false, actions: [], mutations: [] };
  },
  set_bug_meta(state, meta_data){
    state.meta_data = meta_data;
  },
  set_open_bugs(state, bugs){
    state.open_bugs = [
      ...state.open_bugs,
      ...bugs
    ];
  },
  remove_open_bug(state, index){
    state.open_bugs.splice(index, 1);
  },
  set_dev_bugs(state, bugs){
    state.dev_bugs = [
      ...state.dev_bugs,
      ...bugs
    ];
  },
  set_closed_bugs(state, bugs){
    state.closed_bugs = [
      ...state.closed_bugs,
      ...bugs
    ];
  },
  set_details_dialog(state, payload){
    state.details_dialog = payload;
  },
  set_error(state, err){
    state.error = err;
  },
  set_loading(state, loading){
    state.loading = loading;
  },
  toggle_bug_dialog(state, payload){
    state.bug_dialog = payload;
  },
  set_sort_by(state, payload){
    state.sort_by = payload;
  },
  set_sort_type(state, payload){
    state.sort_type = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
